(function() {
    'use strict';

    angular
        .module('ADTDataMapping', ['ui.router', 'LocalStorageModule',
            'ngMaterial', 'md.data.table', 'toastr', 'ui.knob', 'ngFileSaver', 'timer'
        ]);

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('collectionTypesAdmin', collectionTypesAdmin);

  /** @ngInject */
  function collectionTypesAdmin(config, $http, $mdDialog, collectionTypes, schoolYears) {

    var service = {};

    service.showAddDialog = function() {
      schoolYears.getSchoolYears().then(function(results) {
        $mdDialog.show({
            locals: {
              schoolYearsLocal: _.cloneDeep(results.data)
            },
            controller: 'CollectionTypesAdminAddController',
            controllerAs: 'vm',
            templateUrl: 'app/components/collectionTypes/admin/collectionTypesAdminAdd.html'
          })
          .then(function() {}, function() {});
      });
    };

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .directive('collectionTypesAdmin', collectionTypesAdmin);

  /** @ngInject */
  function collectionTypesAdmin() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/collectionTypes/admin/collectionTypesAdmin.html',
      scope: {},
      controller: CollectionTypesAdmin,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function CollectionTypesAdmin(collectionTypes, collectionTypesAdmin, schoolYears, $scope, $q, $timeout, $log, $document, $mdEditDialog) {
      var vm = this;

      vm.selected = [];
      vm.limitOptions = [5, 10, 15];

      vm.options = {
        rowSelection: true,
        multiSelect: true,
        autoSelect: true,
        decapitate: false,
        largeEditDialog: false,
        boundaryLinks: false,
        limitSelect: true,
        pageSelect: true
      };

      vm.query = {
        order: 'Name',
        limit: 5,
        page: 1
      };

      vm.collectionTypes = [];
      collectionTypes.getCollectionTypes().then(function(results) {
        vm.collectionTypes = results.data;
      });

      vm.addItem = function() {
        collectionTypesAdmin.showAddDialog();
      };

      vm.editDescription = function(event, collectionType) {
        event.stopPropagation(); // in case autoselect is enabled

        var editDialog = {
          modelValue: collectionType.description,
          placeholder: 'Add a description',
          save: function(input) {
            collectionType.Description = input.$modelValue;
          },
          targetEvent: event,
          title: 'Add a description',
          validators: {
            'md-maxlength': 30
          }
        };

        var promise;

        if (vm.options.largeEditDialog) {
          promise = $mdEditDialog.large(editDialog);
        } else {
          promise = $mdEditDialog.small(editDialog);
        }

        promise.then(function(ctrl) {
          var input = ctrl.getInput();

          input.$viewChangeListeners.push(function() {
            input.$setValidity('test', input.$modelValue !== 'test');
          });
        });
      };

      vm.toggleLimitOptions = function() {
        vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 15];
      };

      vm.loadStuff = function() {
        vm.promise = $timeout(function() {
          // loading
        }, 2000);
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .controller('CollectionTypesAdminAddController', CollectionTypesAdminAddController);

  /** @ngInject */
  function CollectionTypesAdminAddController($mdDialog, collectionTypes, schoolYearsLocal) {
    var vm = this;

    vm.item = {
      name: '',
      description: '',
      inactive: false,
      schoolYear: ''
    };

    vm.schoolYearsOrig = _.cloneDeep(schoolYearsLocal);
    vm.schoolYears = schoolYearsLocal;

    vm.saveItem = function() {
      var schoolYearID = _.find(vm.schoolYearsOrig, function(o) {
        return o.Name === vm.item.schoolYear;
      }).ID;
      collectionTypes.addCollectionType(vm.item.name, vm.item.description, vm.item.inactive, schoolYearID);
      $mdDialog.hide(vm.item);
    };

    vm.closeDialog = function() {
      $mdDialog.hide();
    };
  }

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('OptionMappingTableController', OptionMappingTableController);

    /** @ngInject */
    function OptionMappingTableController($q, $timeout, $mdEditDialog, $mdDialog, $scope) {
        var vm = this;

        vm.selected = [];
        vm.limitOptions = [5, 10, 50];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: true,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };

        vm.query = {
            order: 'Name',
            limit: 5,
            page: 1
        };

        vm.getErrorsString = function(errors) {
            return _.map(_.orderBy(errors, ['Count'], ['desc']), function(o) {
                return o.Value + '(' + o.Count + ')'
            }).join(' ,');
        }

        vm.setSISValueNull = function(opt) {
            if (opt.isNULL) {
                opt.originalSISValue = opt.SISValue;
                opt.SISValue = '[NOT IN SIS]';
            } else {
                opt.SISValue = opt.originalSISValue ? opt.originalSISValue : '[NOT IN SIS]';
            }
        }

        vm.editSISValue = function(event, opt, leaOSSEOptionMappings) {
            event.stopPropagation();

            vm.optionError = '';
            var options = angular.copy(leaOSSEOptionMappings);

            var editDialog = {
                modelValue: opt.SISValue,
                placeholder: 'Map to the SIS Option',
                title: 'Separate multiple values with commas. Map [NULL] for blank values.',
                ok: 'Ok',
                clickOutsideToClose: true,
                escToClose: true,
                save: function(input) {

                    var currentOptionID = opt.ID;

                    var currentOptions = _.flatMap(options, function(op) {
                        if (currentOptionID != op.ID)
                            return op.SISValue ? op.SISValue.toLowerCase().split(',') : '';
                    });
                    currentOptions = _.map(currentOptions, _.trim);

                    var newOptionsSplit = input.$modelValue.toLowerCase().split(',');
                    newOptionsSplit = _.map(newOptionsSplit, _.trim);

                    var errorOptions = _.uniq(_.filter(newOptionsSplit, function(o) {
                        return currentOptions.indexOf(o.toLowerCase()) >= 0;
                    }));
                    errorOptions = _.map(errorOptions, _.trim);

                    errorOptions = _.pull(errorOptions, '');
                    if (errorOptions.length == 1) {
                        vm.optionError = 'Oops! The option: "' + errorOptions + '" has already been mapped. Please pick a unique value.';
                    } else if (errorOptions.length > 1) {
                        vm.optionError = 'Oops! The options: "' + errorOptions.join() + '" have already been mapped. Please pick unique values.';
                    } else {
                        var uniqueNewOptions = _.uniqWith(input.$modelValue.split(','), function(arrVal, othVal) {
                            return arrVal.toLowerCase().trim() === othVal.toLowerCase().trim();
                        });
                        uniqueNewOptions = _.map(uniqueNewOptions, _.trim);
                        uniqueNewOptions = _.pull(uniqueNewOptions, '');
                        input.$modelValue = uniqueNewOptions.join();

                        if (input.$modelValue) {
                            opt.SISValue = input.$modelValue;
                        } else {
                            opt.isNULL = true;
                            vm.setSISValueNull(opt);
                        }
                    }
                },
                targetEvent: event
            };

            if (vm.options.largeEditDialog) {
                $mdEditDialog.large(editDialog);
            } else {
                $mdEditDialog.small(editDialog);
            }
        };

        vm.toggleLimitOptions = function() {
            vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 50];
        };

        vm.closeDialog = function() {
            $mdDialog.cancel();
        }

        vm.optionMap.LEAOSSEOptionMappings = _.map(vm.optionMap.LEAOSSEOptionMappings, function(o) {
            return _.extend({}, o, {
                isNULL: o.SISValue === '[NOT IN SIS]'
            });
        });

        $scope.$watch('vm.query.filter', function() {
            vm.query.page = 1;
        });
    }

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('MappingsHistoryController', MappingsHistoryController);

    /** @ngInject */
    function MappingsHistoryController(mappingSvc, $mdDialog, $window, $scope, $stateParams) {
        var vm = this;

        vm.loading = true;

        vm.limitOptions = [5, 10, 50];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };

        vm.query = {
            limit: 10,
            page: 1
        };

        vm.resetFilters = function() {
            vm.filter = {
                lea: '',
                schoolYear: '',
                collectionType: '',
                search: ''
            }
            vm.leaFilters = [];
            vm.schoolYearFilters = [];
            vm.collectionTypeFilters = [];
            vm.leaFilterDisabled = true;
            vm.schoolYearFilterDisabled = true;
            vm.collectionTypeFilterDisabled = true;
            vm.mappingsHistory = [];
        };

        vm.updateMappings = function() {
            vm.loading = true;
            mappingSvc.updateMappings(vm.mappingsHistory)
                .then(function() {
                    vm.loading = false;
                });
        };

        vm.schoolYearFilterSelected = function() {
            var previousLEACode = vm.filter.lea.Code;
            vm.mappingsHistory = [];

            vm.collectionTypeFilters = [];
            vm.collectionTypeFilterDisabled = true;

            vm.leaFilters = _.orderBy(vm.filter.schoolYear.LEAs, ['Name'], ['asc']);
            if (vm.leaFilters.length) {
                vm.leaFilterDisabled = false;
                var leaID = $stateParams.lea;
                vm.filter.lea = !leaID ? vm.leaFilters[0] : _.find(vm.leaFilters, ['ID', parseInt(leaID)]);
                var leaByCode = _.find(vm.leaFilters, ['Code', previousLEACode]);
                if ((!vm.filter.lea || previousLEACode != vm.filter.lea.Code) && leaByCode) {
                    vm.filter.lea = leaByCode;
                }
                vm.leaFilterSelected();
            }
        };

        vm.leaFilterSelected = function() {
            var previousCollectionTypeName = vm.filter.collectionType.Name;
            vm.mappingsHistory = [];

            vm.collectionTypeFilters = _.orderBy(vm.filter.lea.CollectionTypes, ['Name'], ['asc']);
            if (vm.collectionTypeFilters.length) {
                var collectionTypeID = $stateParams.collectionType;
                vm.filter.collectionType = !collectionTypeID ? vm.collectionTypeFilters[0] : _.find(vm.collectionTypeFilters, ['ID', parseInt(collectionTypeID)]);
                var collectionTypeByName = _.find(vm.collectionTypeFilters, ['Name', previousCollectionTypeName])
                if ((!vm.filter.collectionType || previousCollectionTypeName != vm.filter.collectionType.Name) && collectionTypeByName) {
                    vm.filter.collectionType = collectionTypeByName;
                }
                vm.collectionTypeFilterSelected();
                vm.collectionTypeFilterDisabled = false;
            }
        };

        vm.collectionTypeFilterSelected = function() {
            vm.mappingsHistory = [];
            vm.collectionTypeFilterDisabled = false;

            vm.filter.startDate = vm.filter.startDate || $window.moment().startOf('day').toDate();
            vm.filter.endDate = vm.filter.endDate || $window.moment().endOf('day').toDate();
            vm.filter.maxDate = $window.moment().endOf('day').toDate();
            vm.dateFilterSelected();
        };

        vm.dateFilterSelected = function() {
            vm.loading = true;
            vm.mappingsHistory = [];

            vm.filter.startDate.setHours(0, 0, 0, 0);
            vm.filter.endDate.setHours(22, 59, 59, 999);
            mappingSvc.getHistory(vm.filter.lea, vm.filter.schoolYear, vm.filter.collectionType,
                    vm.filter.startDate.toISOString(), vm.filter.endDate.toISOString())
                .then(function(results) {
                    vm.mappingsHistory = _.orderBy(results.data, ['Updated'], ['desc']);
                    vm.loading = false;

                    vm.leaFilterDisabled = false;
                    vm.schoolYearFilterDisabled = false;
                    vm.collectionTypeFilterDisabled = false;
                });
        };

        vm.showOptionMappingTableDialog = function(optionMap) {
            $mdDialog.show({
                    controller: 'OptionMappingTableController',
                    controllerAs: 'vm',
                    templateUrl: 'app/components/optionMappingTable/optionMappingTable.html',
                    locals: {
                        optionMap: optionMap
                    },
                    bindToController: true,
                    disableParentScroll: true
                })
                .then(function() {}, function() {});
        };

        // Sets the LEA filter contents
        vm.resetFilters();
        mappingSvc.getSummary().then(function(results) {

            vm.schoolYearFilters = _.orderBy(results.data.SchoolYears, ['Name'], ['desc']);

            // Select first SY
            vm.filter.schoolYear = vm.schoolYearFilters[0];
            vm.schoolYearFilterSelected();

            // Select first LEA
            vm.filter.lea = vm.leaFilters[0];
            vm.leaFilterSelected();
        });

        $scope.$watch('vm.query.filter', function() {
            vm.query.page = 1;
        });
    }
})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .directive('gaugeChart', gaugeChart);

  /** @ngInject */
  function gaugeChart() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/gaugeChart/gaugeChart.html',
      scope: {
        value: '=',
        min: '=',
        max: '=',
        literal: '='
      },
      controller: GaugeChartController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function GaugeChartController() {
      var vm = this;

      vm.options = {
        min: vm.min,
        max: vm.max,
        size: 175,
        readOnly: true,
        subText: {
          enabled: true,
          text: 'of ' + vm.max + '' + vm.literal,
          color: 'black',
          font: 'auto'
        },
        trackWidth: 10,
        barWidth: 20,
        trackColor: '#E57373',
        barColor: '#4CAF50'
      };
    }
  }

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('RequiredErrorsTableController', RequiredErrorsTableController);

    /** @ngInject */
    function RequiredErrorsTableController($q, $timeout, $mdEditDialog, $mdDialog, $state, $scope) {
        var vm = this;

        vm.limitOptions = [5, 10, 50];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };

        vm.query = {
            order: 'Name',
            limit: 5,
            page: 1
        };

        vm.toggleLimitOptions = function() {
            vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 50];
        };

        vm.closeDialog = function() {
            $mdDialog.cancel();
        };

        vm.errorMappingMsg = function(SISTableEmpty, SISColumnEmpty) {
            var msg = '';
            if (SISTableEmpty == true && SISColumnEmpty == true)
                msg = 'SIS Table, SIS Column are not Mapped';
            if (SISTableEmpty == true && SISColumnEmpty == false)
                msg = 'SIS Table is not Mapped';
            if (SISTableEmpty == false && SISColumnEmpty == true)
                msg = 'SIS Column is not Mapped';
            if (SISTableEmpty == false && SISColumnEmpty == false)
                msg = '';
            return msg;
        };

        vm.goToEditMappings = function(schoolYearID, leaID, collectionTypeID, mappingFilter) {
            $mdDialog.cancel();
            $state.go('mappings', {
                viewType: 'requiredError',
                schoolYear: schoolYearID,
                lea: leaID,
                collectionType: collectionTypeID,
                mappingFilter: mappingFilter
            });
        };

        $scope.$watch('vm.query.filter', function() {
            vm.query.page = 1;
        });
    }

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('OptionErrorsTableController', OptionErrorsTableController);

    /** @ngInject */
    function OptionErrorsTableController($q, $timeout, $mdEditDialog, $mdDialog, $state, $scope) {
        var vm = this;

        vm.limitOptions = [5, 10, 50];

        vm.options = {
            rowSelection: false,
            multiSelect: false,
            autoSelect: true,
            decapitate: false,
            largeEditDialog: false,
            boundaryLinks: true,
            limitSelect: true,
            pageSelect: true
        };

        vm.query = {
            order: 'Name',
            limit: 5,
            page: 1
        };

        vm.toggleLimitOptions = function() {
            vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 50];
        };

        vm.closeDialog = function() {
            $mdDialog.cancel();
        };

        vm.errorMappingMsg = function(SISTableEmpty, SISColumnEmpty) {
            var msg = '';
            if (SISTableEmpty == true && SISColumnEmpty == true)
                msg = 'SIS Table, SIS Column are not Mapped';
            if (SISTableEmpty == true && SISColumnEmpty == false)
                msg = 'SIS Table is not Mapped';
            if (SISTableEmpty == false && SISColumnEmpty == true)
                msg = 'SIS Column is not Mapped';
            if (SISTableEmpty == false && SISColumnEmpty == false)
                msg = '';
            return msg;
        };

        vm.goToEditMappings = function(schoolYearID, leaID, collectionTypeID, mappingFilter) {
            $mdDialog.cancel();
            $state.go('mappings', {
                viewType: 'optionError',
                schoolYear: schoolYearID,
                lea: leaID,
                collectionType: collectionTypeID,
                mappingFilter: mappingFilter
            });
        };

        $scope.$watch('vm.query.filter', function() {
            vm.query.page = 1;
        });
    }

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .directive('sidenav', sidenav);

  /** @ngInject */
  function sidenav() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sidenav/sidenav.html',
      scope: {},
      controller: SidenavController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidenavController(authSvc, $state, $mdSidenav, applicationUserSvc, $window) {
      var vm = this;

      vm.authentication = authSvc.authentication;
      vm.settings = {
        notificationsEnabled: false
      };

      vm.logOut = function(sidenavID) {
        $state.go('login');
        if ($state.current.name != 'mappings') {
          authSvc.logOut();
        }
        vm.toggleSidenav(sidenavID);
      }

      vm.toggleSidenav = function(sidenavID) {
        $mdSidenav(sidenavID).toggle();
      }

      vm.navigateTo = function(stateID, sidenavID) {
        $state.go(stateID);
        vm.toggleSidenav(sidenavID);
      }

      vm.openExternalUrl = function(url, sidenavID) {
        $window.open(url, '_blank');
        vm.toggleSidenav(sidenavID);
      }

      vm.toggleNotificationsEnabled = function() {
        if (vm.authentication.isOSSEAdmin) {
          applicationUserSvc.updateCurrentApplicationUserSettings(vm.settings.notificationsEnabled)
            .then(function() {}, function() {
              vm.settings.notificationsEnabled = !vm.settings.notificationsEnabled;
            });
        }
      }

      if (vm.authentication.isOSSEAdmin) {
        applicationUserSvc.getCurrentApplicationUserSettings().then(function(results) {
          vm.settings.notificationsEnabled = results.data.NotificationsEnabled;
        });
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('schoolYears', schoolYears);

  /** @ngInject */
  function schoolYears(config, $http) {

    var serviceBase = config.apiUrl;
    var service = {};

    var _getSchoolYears = function() {
      return $http.get(serviceBase + 'api/schoolyears').then(function(results) {
        return results;
      });
    };

    service.getSchoolYears = _getSchoolYears;

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('notifySvc', notifySvc);

  /** @ngInject */
  function notifySvc(config, $http) {

    var serviceBase = config.apiUrl;
    var service = {};

    service.sendOSSESummary = function() {
      return $http.post(serviceBase + 'api/notify/ossesummary').then(function(results) {
        return results;
      });
    };

    service.sendLEASummary = function() {
      return $http.post(serviceBase + 'api/notify/leasummary').then(function(results) {
        return results;
      });
    };

    return service;
  }
})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(authSvc, $mdSidenav) {
      var vm = this;

      vm.authentication = authSvc.authentication;
      vm.toggleSidenav = function() {
        $mdSidenav("sidenav").toggle();
      }
    }
  }

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('collectionTypes', collectionTypes);

  /** @ngInject */
  function collectionTypes(config, $http) {

    var serviceBase = config.apiUrl;
    var service = {};

    service.getCollectionTypes = function() {
      return $http.get(serviceBase + 'api/collectionTypes').then(function(results) {
        return results;
      });
    };

    service.addCollectionType = function(name, description, inactive, schoolYearID) {
      var item = {
        Name: name,
        Description: description,
        Inactive: inactive,
        SchoolYearID: schoolYearID
      }
      return $http.post(serviceBase + 'api/collectionTypes', item)
        .then(function(results) {
          return results;
        });
    };

    service.editCollectionType = function() {};

    service.deleteCollectionType = function() {};

    return service;
  }
})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('SessionTimeoutToastController', SessionTimeoutToastController);

    /** @ngInject */
    function SessionTimeoutToastController(authSvc, $mdDialog, $timeout, $window) {
        var vm = this;

        vm.auth = authSvc.authentication;
        vm.timeLeft = Math.abs($window.moment().diff(authSvc.authentication.expiration, 'seconds'));

        vm.onTimeout = function() {
            vm.timeLeft--;
            if (vm.timeLeft > 0) {
                if (vm.auth.isAuth) {
                    $timeout(vm.onTimeout, 1000);
                }
            }
        }
        $timeout(vm.onTimeout, 1000);

        return vm;
    }
})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('LogoutWarningController', LogoutWarningController);

    /** @ngInject */
    function LogoutWarningController(authSvc, $mdDialog, $timeout, $window, $mdToast) {
        var vm = this;

        vm.auth = authSvc.authentication;
        vm.timeLeft = Math.abs($window.moment().diff(authSvc.authentication.expiration, 'seconds'));

        vm.close = function() {
            $mdDialog.cancel();
            if (vm.auth.isAuth) {
                $mdToast.show({
                    hideDelay: Math.abs($window.moment().diff(authSvc.authentication.expiration, 'milliseconds')),
                    position: 'bottom left',
                    controller: 'SessionTimeoutToastController',
                    controllerAs: 'vm',
                    templateUrl: 'app/components/auth/sessionTimeoutToast.html'
                });
            }
        }

        vm.onTimeout = function() {
            vm.timeLeft--;
            if (vm.timeLeft > 0) {
                if (vm.auth.isAuth) {
                    $timeout(vm.onTimeout, 1000);
                }
            } else {
                authSvc.logOut();
                $mdDialog.show({
                    controller: 'LogoutWarningController',
                    controllerAs: 'vm',
                    templateUrl: 'app/components/auth/logoutWarning.html',
                    clickOutsideToClose: true
                });
            }
        }
        $timeout(vm.onTimeout, 1000);

        return vm;
    }
})();
(function () {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('authInterceptor', authInterceptor);

  /** @ngInject */
  function authInterceptor($q, $location, localStorageService, config, $window) {

    var service = {};

    var _request = function (requestConfig) {

      if (requestConfig.url.indexOf(config.apiUrl) > -1) {
        // Setting the Authorization header with the local storage bearer token if available
        requestConfig.headers = requestConfig.headers || {};

        var authData = localStorageService.get(config.accessTokenLocalStorageKey);
        var isAuth = authData ? !$window.moment().isAfter(authData.expiration) : false;

        if (authData && isAuth) {
          requestConfig.headers.Authorization = 'Bearer ' + authData.token;
        }

        if (!authData && !isAuth && requestConfig.url.indexOf('token') == -1) {
          $location.path('/login');
          requestConfig.url = '/';
        }
      }

      return requestConfig;
    }

    var _responseError = function (rejection) {
      // If there is an error with the local storage bearer token
      // then they are redirected to the login page
      if (rejection.status === 401) {
        $location.path('/login');
      }
      return $q.reject(rejection);
    }

    service.request = _request;
    service.responseError = _responseError;

    return service;
  }
})();

(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .factory('authSvc', authSvc);

    /** @ngInject */
    function authSvc(config, $http, $q, localStorageService, $window, $location, $timeout, $mdDialog, $mdToast) {

        var serviceBase = config.apiUrl;
        var factory = {};

        factory.authentication = {
            isAuth: false,
            username: '',
            role: '',
            isOSSEUser: false,
            isOSSEAdmin: false
        };

        function clearAuthData() {
            factory.authentication.isAuth = false;
            factory.authentication.username = "";
            factory.authentication.role = "";
            factory.authentication.isOSSEUser = false;
            factory.authentication.isOSSEAdmin = false;
            factory.authentication.expiration = 0;
        }

        factory.login = function(username, password) {
            // Specifying the json for Resource Owner Password Credentials grant type token request with username and password
            var data = "grant_type=password&username=" + username + "&password=" + encodeURIComponent(password);

            var deferred = $q.defer();

            $http.post(serviceBase + 'api/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response) {
                // Saves the token in the browser's local storage using the angular local storage library
                localStorageService.set(config.accessTokenLocalStorageKey, {
                    token: response.data.access_token,
                    username: username,
                    role: response.data.role,
                    isOSSEUser: response.data.role.indexOf('OSSEAdmin') !== -1 || response.data.role.indexOf('OSSEUser') !== -1,
                    isOSSEAdmin: response.data.role.indexOf('OSSEAdmin') !== -1,
                    expirationInSeconds: response.data.expires_in,
                    expiration: $window.moment().add(response.data.expires_in, 'seconds')
                });

                factory.fillAuthData();
                factory.startTimeout();

                deferred.resolve(response);
            }, function(err) {
                factory.logOut();
                deferred.reject(err);
            });

            return deferred.promise;
        };

        factory.logOut = function() {
            // Removes the token in the browser's local storage using the angular local storage library
            localStorageService.remove(config.accessTokenLocalStorageKey);
            clearAuthData();
            factory.stopTimeout();
            $location.path('/login');
            $mdToast.cancel();
        };

        factory.fillAuthData = function() {
            // Gets the token in the browser's local storage using the angular local storage library
            var authData = localStorageService.get(config.accessTokenLocalStorageKey);
            if (authData) {
                factory.authentication.isAuth = true;
                factory.authentication.username = authData.username;
                factory.authentication.role = authData.role;
                factory.authentication.isOSSEUser = authData.isOSSEUser;
                factory.authentication.isOSSEAdmin = authData.isOSSEAdmin;
                factory.authentication.expiration = authData.expiration;
                if ($window.moment().isAfter(authData.expiration)) {
                    factory.logOut();
                }
            }
        }

        factory.startTimeout = function() {
            factory.stopTimeout();
            if (factory.authentication.expiration) {
                var diff = Math.abs($window.moment().diff(factory.authentication.expiration, 'milliseconds')) - 60000;
                factory.timer = $timeout(function() {
                    $mdDialog.show({
                        controller: 'LogoutWarningController',
                        controllerAs: 'vm',
                        templateUrl: 'app/components/auth/logoutWarning.html',
                        clickOutsideToClose: true
                    });
                }, diff);
            }
        }

        factory.stopTimeout = function() {
            $timeout.cancel(factory.timer);
        }

        return factory;
    }
})();
(function() {
	'use strict';

	angular
		.module('ADTDataMapping')
		.controller('ApplicationUserAdminEditController', ApplicationUserAdminEditController);

	/** @ngInject */
	function ApplicationUserAdminEditController($mdDialog, applicationUserSvc, authSvc) {
		var vm = this;

		vm.authentication = authSvc.authentication;

		vm.loading = false;

		vm.item = {
			id: '',
			username: '',
			notificationsEnabled: false,
			roleID: ''
		};

		vm.saveItem = function() {
			vm.loading = true;
			if (vm.item.id) {
				if (!vm.item.deleted) {
					applicationUserSvc.updateApplicationUser(vm.item.id, vm.item.username, vm.item.notificationsEnabled, vm.item.roleID)
						.then(function(success) {
							$mdDialog.hide(success.data);
							vm.loading = false;
						}, function(error) {
							vm.errors = error.data;
							vm.loading = false;
						});
				} else {
					applicationUserSvc.deleteApplicationUser(vm.item.id)
						.then(function(success) {
							$mdDialog.hide(success.data);
							vm.loading = false;
						}, function(error) {
							vm.errors = error.data;
							vm.loading = false;
						});
				}
			} else {
				applicationUserSvc.addApplicationUser(vm.item.username, vm.item.notificationsEnabled, vm.item.roleID)
					.then(function(success) {
						$mdDialog.hide(success.data);
						vm.loading = false;
					}, function(error) {
						vm.errors = error.data;
						vm.loading = false;
					});
			}
		};

		vm.closeDialog = function() {
			$mdDialog.hide();
		};

		if (vm.user) {
			vm.item.id = vm.user.ID;
			vm.item.username = vm.user.Username;
			vm.item.notificationsEnabled = vm.user.NotificationsEnabled;
			vm.item.roleID = _.map(vm.user.RoleAssociations, 'ApplicationUserRole.ID')[0];
			vm.item.deleted = vm.deleteUser;
		}

		applicationUserSvc.getApplicationUserRoles().then(function(results) {
			vm.roles = results.data;
		});
	}

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .directive('applicationUserAdmin', applicationUserAdmin);

    /** @ngInject */
    function applicationUserAdmin() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/applicationUserAdmin/applicationUserAdmin.html',
            scope: {},
            controller: ApplicationUserAdmin,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ApplicationUserAdmin(applicationUserSvc, $mdDialog, authSvc, notifySvc) {
            var vm = this;

            vm.authentication = authSvc.authentication;

            vm.selected = [];
            vm.limitOptions = [5, 10, 15];

            vm.options = {
                rowSelection: true,
                multiSelect: false,
                autoSelect: false,
                decapitate: false,
                largeEditDialog: false,
                boundaryLinks: false,
                limitSelect: true,
                pageSelect: true
            };

            vm.query = {
                order: 'Name',
                limit: 5,
                page: 1
            };

            vm.applicationUsers = [];
            vm.loading = applicationUserSvc.getApplicationUsers().then(function(results) {
                vm.applicationUsers = results.data;
            });

            vm.addEditItem = function(item, deleteItem) {
                $mdDialog.show({
                        controller: 'ApplicationUserAdminEditController',
                        controllerAs: 'vm',
                        templateUrl: 'app/components/applicationUserAdmin/applicationUserAdminEdit.html',
                        bindToController: true,
                        disableParentScroll: true,
                        locals: {
                            user: item,
                            deleteUser: deleteItem
                        }
                    })
                    .then(function(item) {
                        if (item) {
                            _.remove(vm.applicationUsers, {
                                ID: item.ID
                            });
                            if (!deleteItem) {
                                vm.applicationUsers.push(item);
                            }
                        }
                        vm.selected = [];
                    }, function() {});
            };

            vm.updateLEAAssociations = function() {
                vm.loading = true;
                applicationUserSvc.updateLEAAssociations()
                    .then(function() {
                        vm.loading = false;
                    }, function() {
                        vm.loading = false;
                    });
            };

            vm.sendOSSESummary = function() {
                vm.loading = true;
                notifySvc.sendOSSESummary()
                    .then(function() {
                        vm.loading = false;
                    }, function() {
                        vm.loading = false;
                    });
            };

            vm.sendLEASummary = function() {
                vm.loading = true;
                notifySvc.sendLEASummary()
                    .then(function() {
                        vm.loading = false;
                    }, function() {
                        vm.loading = false;
                    });
            };

            vm.toggleLimitOptions = function() {
                vm.limitOptions = vm.limitOptions ? undefined : [5, 10, 15];
            };

            vm.getUserRoles = function(user) {
                return _.map(user.RoleAssociations, 'ApplicationUserRole.Name').join(', ');
            }

            vm.getUserLEAs = function(user) {
                var leaNames = [];
                var leaCodes = _.uniq(_.map(user.LEAAssociations, 'LEA.Code'));
                _.forEach(leaCodes, function(code) {
                    var leas = _.filter(user.LEAAssociations, ['LEA.Code', code]);
                    var maxSY = _.maxBy(leas, 'LEA.SchoolYear')
                    leaNames.push(maxSY.LEA.Name);
                });
                return _.uniq(leaNames).join(', ');
            }
        }
    }

})();
(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('applicationUserSvc', applicationUserSvc);

  /** @ngInject */
  function applicationUserSvc(config, $http) {

    var serviceBase = config.apiUrl;
    var service = {};

    service.getApplicationUsers = function() {
      return $http.get(serviceBase + 'api/applicationuser').then(function(results) {
        return results;
      });
    };

    service.getApplicationUserRoles = function() {
      return $http.get(serviceBase + 'api/applicationuserrole').then(function(results) {
        return results;
      });
    };

    service.addApplicationUser = function(username, notificationsEnabled, roleID) {
      var applicationUserDTO = {
        Username: username,
        NotificationsEnabled: notificationsEnabled,
        ApplicationUserRoleID: roleID
      }

      return $http.post(serviceBase + 'api/applicationuser', applicationUserDTO).then(function(results) {
        return results;
      });
    };

    service.updateApplicationUser = function(id, username, notificationsEnabled, roleID) {
      var applicationUserDTO = {
        ID: id,
        Username: username,
        NotificationsEnabled: notificationsEnabled,
        ApplicationUserRoleID: roleID
      }

      return $http.put(serviceBase + 'api/applicationuser', applicationUserDTO).then(function(results) {
        return results;
      });
    };

    service.deleteApplicationUser = function(id) {
      return $http.delete(serviceBase + 'api/applicationuser/?id=' + id).then(function(results) {
        return results;
      });
    };

    service.updateLEAAssociations = function() {
      return $http.post(serviceBase + 'api/applicationuser/updateleas').then(function(results) {
        return results;
      });
    };

    service.getCurrentApplicationUserSettings = function() {
      return $http.get(serviceBase + 'api/applicationuser/current/settings').then(function(results) {
        return results;
      });
    };

    service.updateCurrentApplicationUserSettings = function(notificationsEnabled) {
      var applicationUserSettingsDTO = {
        NotificationsEnabled: notificationsEnabled
      }

      return $http.put(serviceBase + 'api/applicationuser/current/settings', applicationUserSettingsDTO)
        .then(function(results) {
          return results;
        });
    };

    return service;
  }
})();
(function () {
  'use strict';

  angular
    .module('ADTDataMapping')
    .controller('MappingsController', MappingsController);

  /** @ngInject */
  function MappingsController(mappingSvc, $mdDialog, $stateParams, $mdToast, checkMappingChangesSvc, $scope) {
    var vm = this;

    vm.loading = true;

    vm.saveButtonText = "Save Changes";

    vm.isRequiredColumnCompleted = function (leaOSSEMapping) {
      if (!leaOSSEMapping.Required) {
        return true;
      } else {
        return leaOSSEMapping.SISTable && leaOSSEMapping.SISColumn;
      }
    }

    vm.hasMappingErrors = function (leaOSSEMapping) {
      return leaOSSEMapping.LEAOSSEOptionMappingErrors.length;
    }

    vm.getMappingVisibility = function (leaOSSEMapping) {
      if (vm.filter.showErrorsOnly) {
        return _.some(vm.mappings.errors, function (o) {
          return o.OSSEColumn.DisplayName === leaOSSEMapping.OSSEColumn.DisplayName;
        }) || vm.hasMappingErrors(leaOSSEMapping);
      } else {
        return true;
      }
    }

    vm.updateMappingStaticErrors = function () {
      vm.mappings.errors = _.filter(vm.mappings.LEAOSSEMappings, function (o) {
        return !vm.isRequiredColumnCompleted(o);
      });
    }

    vm.resetFilters = function () {
      vm.filter = {
        lea: '',
        schoolYear: '',
        collectionType: '',
        search: ''
      }
      vm.leaFilters = [];
      vm.schoolYearFilters = [];
      vm.collectionTypeFilters = [];
      vm.leaFilterDisabled = true;
      vm.schoolYearFilterDisabled = true;
      vm.collectionTypeFilterDisabled = true;
      vm.mappings = '';
    };

    vm.updateMappings = function () {
      vm.loading = true;
      vm.saveButtonText = "Saving ...";
      mappingSvc.updateMappings(vm.mappings)
        .then(function () {
          vm.loading = false;
          vm.saveButtonText = "Save Changes";
          vm.updateMappingStaticErrors();
          vm.showUpdateToast(true);
          vm.origMappings = angular.copy(vm.mappings);
          checkMappingChangesSvc.removeListener();
          checkMappingChangesSvc.checkFormOnStateChange($scope, vm.mappings, vm.origMappings);
        }, function () {
          vm.loading = false;
          vm.saveButtonText = "Save Changes";
          vm.showUpdateToast(false);
        });
    };

    vm.showUpdateToast = function (success) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(success ? 'Mappings Updated Successfully' : 'Error! Mappings Were Not Updated')
          .position('bottom right')
          .hideDelay(5000)
          .theme(success ? "success-toast" : "failure-toast")
      );
    };

    vm.schoolYearFilterSelected = function ($event) {
      vm.confirmChanges($event,
        function () {
          var previousLEACode = vm.filter.lea.Code;
          vm.mappings = '';
          vm.collectionTypeFilters = [];
          vm.collectionTypeFilterDisabled = true;

          vm.leaFilters = _.orderBy(vm.filter.schoolYear.LEAs, ['Name'], ['asc']);
          if (vm.leaFilters.length) {
            vm.leaFilterDisabled = false;
            var leaID = $stateParams.lea;
            vm.filter.lea = !leaID ? vm.leaFilters[0] : _.find(vm.leaFilters, ['ID', parseInt(leaID)]);
            var leaByCode = _.find(vm.leaFilters, ['Code', previousLEACode]);
            if ((!vm.filter.lea || previousLEACode != vm.filter.lea.Code) && leaByCode) {
              vm.filter.lea = leaByCode;
            }
            vm.leaFilterSelected();
          }
        },
        function () {
          vm.filter.schoolYear = vm.filter.initSchoolYear;
        });
    };

    vm.leaFilterSelected = function ($event) {
      vm.confirmChanges($event,
        function () {
          var previousCollectionTypeName = vm.filter.collectionType.Name;
          vm.mappings = '';
          vm.collectionTypeFilters = _.orderBy(vm.filter.lea.CollectionTypes, ['Name'], ['asc']);
          if (vm.collectionTypeFilters.length) {
            var collectionTypeID = $stateParams.collectionType;
            vm.filter.collectionType = !collectionTypeID ? vm.collectionTypeFilters[0] : _.find(vm.collectionTypeFilters, ['ID', parseInt(collectionTypeID)]);
            var collectionTypeByName = _.find(vm.collectionTypeFilters, ['Name', previousCollectionTypeName])
            if ((!vm.filter.collectionType || previousCollectionTypeName != vm.filter.collectionType.Name) && collectionTypeByName) {
              vm.filter.collectionType = collectionTypeByName;
            }
            vm.collectionTypeFilterSelected();
            vm.collectionTypeFilterDisabled = false;
          }
        },
        function () {
          vm.filter.lea = vm.filter.initLEA;
        });
    };

    vm.collectionTypeFilterSelected = function ($event) {
      vm.loading = true;

      vm.leaFilterDisabled = true;
      vm.schoolYearFilterDisabled = true;
      vm.collectionTypeFilterDisabled = true;

      vm.saveButtonText = "Loading ...";

      vm.confirmChanges($event, vm.getMappings, function () {
        vm.filter.collectionType = vm.filter.initCollectionType;
        vm.loadingCompleted();
      });
    };

    vm.getMappings = function () {
      vm.mappings = '';
      vm.filter.initSchoolYear = vm.filter.schoolYear;
      vm.filter.initLEA = vm.filter.lea;
      vm.filter.initCollectionType = vm.filter.collectionType;
      mappingSvc.getMappings(vm.filter.lea, vm.filter.schoolYear, vm.filter.collectionType)
        .then(function (results) {
          vm.mappings = results.data;

          if ($stateParams.mappingFilter) {
            if ($stateParams.viewType === "requiredError") {
              vm.filter.showErrorsOnly = true;
            }
            if ($stateParams.viewType === "optionError") {
              var optionErrorItems = _.partition(vm.mappings.LEAOSSEMappings, function (o) {
                return vm.hasMappingErrors(o);
              });
              vm.mappings.LEAOSSEMappings = optionErrorItems[0].concat(optionErrorItems[1]);
            }

            var searchItems = _.partition(vm.mappings.LEAOSSEMappings, function (o) {
              return o.OSSEColumn.DisplayName === $stateParams.mappingFilter;
            });

            vm.mappings.LEAOSSEMappings = searchItems[0].concat(searchItems[1]);
          }

          vm.updateMappingStaticErrors();

          vm.loadingCompleted();

          vm.origMappings = angular.copy(vm.mappings);
          if (checkMappingChangesSvc.removeListener) {
            checkMappingChangesSvc.removeListener();
          }
          checkMappingChangesSvc.checkFormOnStateChange($scope, vm.mappings, vm.origMappings);
        });
    };

    vm.loadingCompleted = function () {
      vm.loading = false;
      vm.saveButtonText = "Save Changes";

      vm.leaFilterDisabled = false;
      vm.schoolYearFilterDisabled = false;
      vm.collectionTypeFilterDisabled = false;

      vm.editingDisabled = vm.filter.schoolYear.IsPastDisabledDate;
    };

    vm.confirmChanges = function ($event, successCallback, failureCallback) {
      if (vm.origMappings && vm.mappings && checkMappingChangesSvc.didMappingsChange(vm.mappings, vm.origMappings)) {
        var confirm = $mdDialog.confirm()
          .textContent('Would you like to continue without saving your changes?')
          .targetEvent($event)
          .ok('Yes')
          .cancel('No');
        $mdDialog.show(confirm).then(function () {
          successCallback();
        }, function () {
          failureCallback();
        });
      } else {
        successCallback();
      }
    };

    vm.showOptionMappingTableDialog = function (optionMap) {
      $mdDialog.show({
        controller: 'OptionMappingTableController',
        controllerAs: 'vm',
        templateUrl: 'app/mappings/optionMappingTable/optionMappingTable.html',
        locals: {
          optionMap: optionMap,
          editingDisabled: vm.filter.schoolYear.IsPastDisabledDate
        },
        bindToController: true,
        disableParentScroll: true
      })
        .then(function () { }, function () { });
    };

    // Sets the LEA filter contents
    vm.resetFilters();
    mappingSvc.getSummary().then(function (results) {

      vm.schoolYearFilters = _.orderBy(results.data.SchoolYears, ['Name'], ['desc']);

      var schoolYearID = $stateParams.schoolYear;

      // Select first SY
      if (schoolYearID) {
        vm.filter.schoolYear = _.find(vm.schoolYearFilters, ['ID', parseInt(schoolYearID)]);
        vm.schoolYearFilterSelected();
      } else {
        vm.loadingCompleted();
        vm.leaFilterDisabled = true;
        vm.collectionTypeFilterDisabled = true;
      }
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .factory('mappingSvc', mappingSvc);

    /** @ngInject */
    function mappingSvc(config, $http, $window, $log, $document, FileSaver, Blob) {

        var serviceBase = config.apiUrl;
        var service = {};

        service.getSummary = function() {
            return $http.get(serviceBase + 'api/mapping/summary').then(function(results) {
                return results;
            });
        };

        service.getSummaryDetails = function(lea, schoolYear) {
            return $http.get(serviceBase + 'api/mapping/summary/details?leaID=' + lea.ID + '&schoolYearID=' + schoolYear.ID)
                .then(function(results) {
                    return results;
                });
        };

        service.getMappings = function(lea, schoolYear, collectionType) {
            return $http.get(serviceBase + 'api/mapping?leaID=' + lea.ID + '&schoolYearID=' + schoolYear.ID + '&collectionTypeID=' + collectionType.ID)
                .then(function(results) {
                    return results;
                });
        };

        service.updateMappings = function(leaMapping) {
            return $http.put(serviceBase + 'api/mapping', leaMapping)
                .then(function(results) {
                    return results;
                });
        };

        service.getHistory = function(lea, schoolYear, collectionType, startDate, endDate) {
            return $http.get(serviceBase + 'api/mapping/history?leaID=' + lea.ID + '&schoolYearID=' + schoolYear.ID + '&collectionTypeID=' + (collectionType.ID ? collectionType.ID : '0') + '&startDate=' + startDate + '&endDate=' + endDate)
                .then(function(results) {
                    return results;
                });
        };

        service.getExport = function(lea, schoolYear) {
            var path = serviceBase + 'api/mapping/export?leaID=' + lea + '&schoolYearID=' + schoolYear
            return $http.get(path, {
                    responseType: 'arraybuffer'
                })
                .then(function(data) {
                    var octetStreamMime = 'application/octet-stream';
                    data = new Blob([data.data], {
                        type: octetStreamMime
                    });
                    FileSaver.saveAs(data, 'mappings.xlsx');
                },function(data, status) {
                    $log.log("Request failed with status: " + status);
                });
        };

        return service;
    }

})();

(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .factory('checkMappingChangesSvc', checkMappingChangesSvc);

  /** @ngInject */
  function checkMappingChangesSvc($rootScope, $mdDialog, $state, authSvc, $window) {

    var factory = {};

    factory.checkFormOnStateChange = function($scope, mappings, origMappings) {

      var removeListener = $rootScope.$on('$stateChangeStart', function(event, toState) {

        if (toState.name == 'login' && $window.moment().isAfter(authSvc.authentication.expiration)) {
          mappings = origMappings;
          authSvc.logOut();
          return;
        }

        if (!factory.didMappingsChange(mappings, origMappings)) {
          if (toState.name == 'login') {
            mappings = origMappings;
            authSvc.logOut();
          }
          return;
        }

        var confirm = $mdDialog.confirm()
          .textContent('Would you like to continue without saving your changes?')
          .targetEvent(event)
          .ok('Yes')
          .cancel('No');
        $mdDialog.show(confirm).then(function() {
          mappings = origMappings;
          if (toState.name == 'login') {
            authSvc.logOut();
          }
          $state.go(toState.name);
        }, function() {
          event.preventDefault();
        });

        event.preventDefault();
      });

      $scope.$on("$destroy", removeListener);

      factory.removeListener = removeListener;
    };

    factory.didMappingsChange = function(mappings, origMappings) {
      var mappingsCopy = angular.copy(mappings);
      mappingsCopy.LEAOSSEMappings = _(mappingsCopy.LEAOSSEMappings).forEach(function(n) {
        delete n['showDetails'];
        n.LEAOSSEOptionMappings = _(n.LEAOSSEOptionMappings).forEach(function(op) {
          delete op['isNULL'];
          delete op['originalSISValue'];
          op.SISValue = (op.SISValue || '').toLowerCase().trim();
        });
        n.SISTable = n.SISTable ? n.SISTable : '';
        n.SISColumn = n.SISColumn ? n.SISColumn : '';
      });

      mappingsCopy.LEACollectionTypes = _(mappingsCopy.LEACollectionTypes).forEach(function(n) {
        delete n['showQuery'];
      });

      var origMappingsCopy = angular.copy(origMappings);
      origMappingsCopy.LEAOSSEMappings = _(origMappingsCopy.LEAOSSEMappings).forEach(function(n) {
        delete n['showDetails'];
        n.LEAOSSEOptionMappings = _(n.LEAOSSEOptionMappings).forEach(function(op) {
          delete op['isNULL'];
          delete op['originalSISValue'];
          op.SISValue = (op.SISValue || '').toLowerCase().trim();
        });
        n.SISTable = n.SISTable ? n.SISTable : '';
        n.SISColumn = n.SISColumn ? n.SISColumn : '';
      });

      origMappingsCopy.LEACollectionTypes = _(origMappingsCopy.LEACollectionTypes).forEach(function(n) {
        delete n['showQuery'];
      });

      origMappingsCopy.LEAOSSEMappings = _(origMappingsCopy.LEAOSSEMappings).forEach(function(n) {
        n.LEAOSSEOptionMappings = _(n.LEAOSSEOptionMappings).forEach(function(op) {
          op.SISValue = op.SISValue.toLowerCase().trim();
        });
      });

      return angular.toJson(mappingsCopy) != angular.toJson(origMappingsCopy);
    };

    return factory;
  }
})();
(function () {
    'use strict';

    angular
        .module('ADTDataMapping')
        .controller('NdaController', NdaController);

    /** @ngInject */
    function NdaController(authSvc, $mdDialog, $timeout, $window) {
        var vm = this;

        vm.auth = authSvc.authentication;
        vm.timeLeft = Math.abs($window.moment().diff(authSvc.authentication.expiration, 'seconds'));

        vm.close = function () {
            $mdDialog.cancel();
        }

        vm.accept = function () {
            $mdDialog.hide();
        }

        return vm;
    }
})();
(function () {
	'use strict';

	angular
		.module('ADTDataMapping')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($location, authSvc, $mdDialog) {
		var vm = this;

		vm.username = '';
		vm.password = '';
		vm.checkCredentials = checkCredentials;
		vm.errors = '';
		vm.loading = false;

		function checkCredentials() {
			$mdDialog.show({
				controller: 'NdaController',
				controllerAs: 'vm',
				templateUrl: 'app/login/nda.html',
				bindToController: true,
				disableParentScroll: true
			}).then(function () {
				vm.loading = true;
				authSvc.login(vm.username, vm.password).then(function () {
					$location.path('/collectiontypes');
				}, function (err) {
					vm.loading = false;
					vm.errors = err.error_description;
				});
			}, function () { });
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('ADTDataMapping')
		.controller('LayoutController', LayoutController);

	/** @ngInject */
	function LayoutController() {}
})();
(function () {
  'use strict';

  angular
    .module('ADTDataMapping')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(mappingSvc, $mdDialog, $state, $mdToast) {
    var vm = this;

    vm.options = {
      size: 200
    };

    vm.goToEditMappings = function (schoolYearID, leaID, collectionTypeID) {
      $state.go('mappings', {
        schoolYear: schoolYearID,
        lea: leaID,
        collectionType: collectionTypeID
      });
    };

    vm.getRequiredChartValue = function (leaOSSEMappings) {
      return leaOSSEMappings.length - vm.getIncompleteMappings(leaOSSEMappings).length;
    };

    vm.getRequiredChartOptions = function (max) {
      return {
        dynamicOptions: true,
        max: max,
        size: 200
      };
    };

    vm.resetFilters = function () {
      vm.filter = {
        lea: '',
        schoolYear: '',
        collectionType: '',
        search: ''
      }
      vm.leaFilters = [];
      vm.schoolYearFilters = [];
      vm.collectionTypes = [];
      vm.leaFilterDisabled = true;
      vm.schoolYearFilterDisabled = true;
    };

    vm.schoolYearFilterSelected = function () {
      var previousLEACode = vm.filter.lea.Code;
      vm.collectionTypes = [];

      vm.leaFilters = _.orderBy(vm.filter.schoolYear.LEAs, ['Name'], ['asc']);
      if (vm.leaFilters.length) {
        vm.leaFilterDisabled = false;
        vm.filter.lea = vm.leaFilters[0];
        if (previousLEACode != vm.filter.lea.Code && _.find(vm.leaFilters, ['Code', previousLEACode])) {
          vm.filter.lea = _.find(vm.leaFilters, ['Code', previousLEACode]);
        }
        vm.leaFilterSelected();
        vm.leaFilterDisabled = false;
      }
    };

    vm.leaFilterSelected = function () {
      vm.loading = true;

      mappingSvc.getSummaryDetails(vm.filter.lea, vm.filter.schoolYear)
        .then(function (results) {
          vm.collectionTypes = results.data;

          vm.loading = false;
          vm.schoolYearFilterDisabled = false;

          vm.editingDisabled = !vm.filter.schoolYear.CurrentSchoolYear;
        });
    };

    vm.isCollectionTypeIncomplete = function (leaOSSEMappings) {
      return _.some(leaOSSEMappings.LEAOSSEOptionMappingErrors, function (c) {
        return c.SISTableEmpty || c.SISColumnEmpty;
      });
    };

    vm.showRequiredErrorsTableDialog = function (leaOSSERequiredMappings, schoolYear, lea, collectionType) {
      $mdDialog.show({
        controller: 'RequiredErrorsTableController',
        controllerAs: 'vm',
        templateUrl: 'app/dashboard/requiredErrorsTable/requiredErrorsTable.html',
        locals: {
          leaOSSERequiredMappings: leaOSSERequiredMappings,
          schoolYear: schoolYear,
          lea: lea,
          collectionType: collectionType
        },
        bindToController: true,
        disableParentScroll: true
      })
        .then(function () { }, function () { });
    };

    vm.showOptionErrorsTableDialog = function (LEAOSSEOptionMappingErrors, schoolYear, lea, collectionType) {
      $mdDialog.show({
        controller: 'OptionErrorsTableController',
        controllerAs: 'vm',
        templateUrl: 'app/dashboard/optionErrorsTable/optionErrorsTable.html',
        locals: {
          LEAOSSEOptionMappingErrors: LEAOSSEOptionMappingErrors,
          schoolYear: schoolYear,
          lea: lea,
          collectionType: collectionType
        },
        bindToController: true,
        disableParentScroll: true
      })
        .then(function () { }, function () { });
    };

    vm.getIncompleteMappings = function (leaOSSEMappings) {
      return _.filter(leaOSSEMappings, function (mapping) {
        return mapping.SISTableEmpty || mapping.SISColumnEmpty;
      });
    };

    vm.getMappingsExport = function (leaID, schoolYearID) {
      vm.exporting = true;
      mappingSvc.getExport(leaID, schoolYearID)
        .then(function () {
          vm.exporting = false;
        }, function () {
          vm.exporting = false;
          $mdToast.show(
            $mdToast.simple()
              .position('bottom right')
              .hideDelay(5000).content("Failed to Export Mappings")
              .theme("failure-toast"));
        });
    };

    // Sets the LEA filter contents
    vm.resetFilters();
    mappingSvc.getSummary().then(function (results) {

      vm.schoolYearFilters = _.orderBy(results.data.SchoolYears, ['Name'], ['desc']);
      vm.schoolYearFilterDisabled = false;
    });
  }
})();

(function() {
	'use strict';

	angular
		.module('ADTDataMapping')
		.controller('AdminController', AdminController);

	/** @ngInject */
	function AdminController() {}
})();
(function() {
	'use strict';

	angular
		.module('ADTDataMapping')
		.run(runBlock);

	/** @ngInject */
	function runBlock($log, authSvc) {
		authSvc.fillAuthData();
		authSvc.startTimeout();
	}

})();
(function() {
    'use strict';

    angular
        .module('ADTDataMapping')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main', {
                abstract: true,
                templateUrl: 'app/layout/layout.html'
            })
            .state('dashboard', {
                url: '/dashboard',
                parent: 'main',
                templateUrl: 'app/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm'
            })
            .state('mappings', {
                url: '/mappings',
                parent: 'main',
                templateUrl: 'app/mappings/mappings.html',
                controller: 'MappingsController',
                controllerAs: 'vm',
                params: {
                    schoolYear: null,
                    lea: null,
                    collectionType: null,
                    viewType: null,
                    mappingFilter: null
                }
            })
            .state('mappingsHistory', {
                url: '/mappings/history',
                parent: 'main',
                templateUrl: 'app/mappings/history/mappingsHistory.html',
                controller: 'MappingsHistoryController',
                controllerAs: 'vm'
            })
            .state('scheduler', {
                url: '/scheduler',
                parent: 'main',
                templateUrl: 'app/scheduler/scheduler.html'
            })
            .state('login', {
                url: '/login',
                parent: 'main',
                templateUrl: 'app/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('admin', {
                url: '/settings/admin',
                parent: 'main',
                templateUrl: 'app/admin/admin.html',
                controller: 'AdminController',
                controllerAs: 'admin'
            });

        $urlRouterProvider.otherwise('/dashboard');
    }

})();
(function () {
    'use strict';

    angular
        .module('ADTDataMapping')
        .constant('config', {
            apiUrl: 'https://data.osse.dc.gov/ldm/',
            // apiUrl: 'https://qa.osse.dc.gov/ldm/',
            // apiUrl: 'http://ossesdev19.dcgov.priv/ldm/',
            accessTokenLocalStorageKey: 'authorizationData'
        });

})();

(function() {
  'use strict';

  angular
    .module('ADTDataMapping')
    .config(config);

  /** @ngInject */
  function config($locationProvider, $logProvider, $httpProvider, $mdThemingProvider, $compileProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    $compileProvider.debugInfoEnabled(false);

    $httpProvider.interceptors.push('authInterceptor');

    $mdThemingProvider.theme('default')
      .primaryPalette('blue')
      .accentPalette('orange')
      .warnPalette('red')
      .backgroundPalette('grey');

    $mdThemingProvider.theme("success-toast");
    $mdThemingProvider.theme("failure-toast");
  }

})();
angular.module("ADTDataMapping").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.html","<application-user-admin></application-user-admin>");
$templateCache.put("app/dashboard/dashboard.html","<md-progress-linear class=md-warn md-mode=indeterminate ng-show=vm.loading></md-progress-linear><div><md-card md-theme=default class=\"dashboard-card-filter md-whiteframe-4dp\"><md-card-content layout=column><section layout-gt-sm=row layout=column><md-input-container flex=30 class=md-accent><label>School Year</label><md-select class=md-accent ng-model=vm.filter.schoolYear ng-change=vm.schoolYearFilterSelected() placeholder=\"Select a School Year\" ng-disabled=\"vm.schoolYearFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=sy ng-repeat=\"sy in vm.schoolYearFilters\">{{sy.Name}}</md-option></md-select></md-input-container><span flex=5></span><md-input-container flex=30 class=md-accent><label>LEA</label><md-select class=md-accent ng-model=vm.filter.lea ng-change=vm.leaFilterSelected() placeholder=\"Select an LEA\" ng-disabled=\"vm.leaFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=lea ng-repeat=\"lea in vm.leaFilters\">{{lea.Name}}</md-option></md-select></md-input-container><span flex></span><md-button ng-if=\"vm.filter.lea.ID && vm.filter.schoolYear.ID\" ng-click=vm.getMappingsExport(vm.filter.lea.ID,vm.filter.schoolYear.ID)>Export Mappings<md-icon>file_download</md-icon><md-progress-linear class=md-warn ng-show=vm.exporting md-mode=indeterminate></md-progress-linear></md-button></section></md-card-content></md-card></div><div layout-gt-xs=row layout=column layout-wrap class=backdrop><section flex=20 flex-gt-sm=shrink layout=column ng-repeat=\"ct in vm.collectionTypes\" ng-hide=vm.loading><md-card class=\"{{vm.editingDisabled ? \'no-op-errors\' : \'\'}} dashboard-card md-whiteframe-1dp\" md-theme=default><md-card-header style=padding:0px ng-click=\"vm.goToEditMappings(vm.filter.schoolYear.ID, vm.filter.lea.ID, ct.ID)\"><md-card-header-text class=md-button><span class=md-body-2>{{ct.Name}}</span></md-card-header-text></md-card-header><md-divider></md-divider><section layout=column><md-card-content ng-click=\"vm.getRequiredChartValue(ct.LEAOSSEMappingRequired) == ct.LEAOSSEMappingRequired.length || vm.showRequiredErrorsTableDialog(vm.getIncompleteMappings(ct.LEAOSSEMappingRequired),vm.filter.schoolYear.ID,vm.filter.lea.ID,ct.ID)\" class=\"action-button md-button\" layout=column ng-disabled=\"vm.getRequiredChartValue(ct.LEAOSSEMappingRequired) == ct.LEAOSSEMappingRequired.length\"><gauge-chart ng-show=\"ct.LEAOSSEMappingRequired.length > 0\" value=vm.getRequiredChartValue(ct.LEAOSSEMappingRequired) min=0 max=ct.LEAOSSEMappingRequired.length literal=\"\' Completed\'\"></gauge-chart>{{vm.getRequiredChartValue(ct.LEAOSSEMappingRequired) == ct.LEAOSSEMappingRequired.length ? \'Completed Required Mappings\' : \'Complete Required Mappings\'}}</md-card-content><md-divider ng-hide=vm.editingDisabled></md-divider><md-card-content layout=column flex=nogrow class=\"md-button action-button\" ng-click=\"!ct.LEAOSSEOptionMappingErrors.length || vm.showOptionErrorsTableDialog(ct.LEAOSSEOptionMappingErrors,vm.filter.schoolYear.ID,vm.filter.lea.ID,ct.ID)\" ng-disabled=!ct.LEAOSSEOptionMappingErrors.length ng-hide=vm.editingDisabled><span class=\"md-caption error-metric-caption\">Unknown Options Sent to ADT</span> <span ng-class=\"ct.LEAOSSEOptionMappingErrors.length ? \'md-display-3 error-metric\' : \'md-display-3 success-metric\'\">{{ct.LEAOSSEOptionMappingErrors.length}}</span> <span ng-show=ct.LEAOSSEOptionMappingErrors.length>Fix Option Errors</span></md-card-content></section></md-card></section></div>");
$templateCache.put("app/login/login.html","<md-progress-linear class=md-warn md-mode=indeterminate ng-show=vm.loading></md-progress-linear><br><div layout=row><span flex=25></span><md-card class=md-whiteframe-1dp md-theme=default flex><md-card-header><md-card-header-text><span class=md-title>Log in with your SLED Credentials</span></md-card-header-text></md-card-header><md-divider></md-divider><md-card-content layout=column layout-align=center><md-input-container class=md-accent><label>Username</label><input ng-model=vm.username type=email ng-required=true class=md-accent></md-input-container><md-input-container class=md-accent><label>Password</label><input ng-model=vm.password type=password ng-required=true class=md-accent></md-input-container><p style=\"margin-top:-20px; padding-bottom:10px; text-align:center\" ng-show=\"vm.errors !== \'\'\"><md-icon style=color:#E57373>error</md-icon>{{vm.errors}}</p><md-button type=submit class=\"md-raised md-primary\" ng-disabled=vm.loading ng-click=vm.checkCredentials()>Login</md-button><p layout-padding>The Office of the State Superintendent of Education (OSSE) is excited to launch the LEA Data Mapping Application. This system captures the tables, columns and field values from the LEA SIS to ensure accurate completion of the Demographic, Enrollment, Contacts and Attendance Collections.</p></md-card-content><md-divider></md-divider><md-card-content><p class=md-body-1 layout-padding>For the best experience, we encourage you to use the latest version of Google Chrome, Mozilla Firefox, Apple Safari, or Microsoft Edge. <a href=http://browsehappy.com/ >Click here</a>for more details.</p></md-card-content></md-card><span flex=25></span></div>");
$templateCache.put("app/login/nda.html","<md-dialog id=session-timeout-dialog><form><md-dialog-content><md-content class=md-padding><p>I certify that I am currently employed by an authorized representative of the Office of the State Superintendent of Education (OSSE), and that I am accessing educational records in the LEA Data Mapping application solely for evaluation, audit, enforcement, or compliance activities pursuant to an active data-sharing agreement with OSSE. I agree not to access any information of my friends, family, neighbors, co-workers, public figures, or other persons unless that information is legitimately necessary to carry out the OSSE-approved activities. I agree to protect any data that I access from further disclosure to any other person or entity. When I no longer need the data that I access from the LEA Data Mapping application, I agree to destroy the data in accordance with the data-sharing agreement with OSSE.</p><strong>Data Privacy Information</strong><p>The data contained in the LEA Data Mapping application is kept confidential pursuant to the Family Educational Rights and Privacy Act (FERPA), which is a Federal law that protects the privacy of student education records, and the FERPA regulations promulgated by the Department of Education (20 U.S.C. § 1232g; 34 CFR Part 99).</p><strong>Protected information includes, but is not limited to, the following:</strong><ul><li>Names of students, parents or other family members</li><li>Addresses</li><li>Identifiers, including school IDs, unique identifiers, and Social Security Numbers</li><li>Age</li><li>Indirect identifiers, date of birth, place of birth, and mother’s maiden name</li><li>Phone numbers (home, cell, office, etc)</li><li>Relatives information</li><li>Educational status/history</li><li>Special Education status/history</li><li>Demographics</li><li>Financial information</li><li>Any other information that, alone or in combination, that would allow a personable person in the school community to identify the student</li></ul><strong>Protection of Data within LEA Data Mapping application</strong><ul><li>Information retrieved from LEA Data Mapping application may be shared only with individuals expressly authorized to receive this information.</li><li>Data must not be “screen scraped” or accessed by automated tools and used in any other program.</li><li>All printed materials are to be marked as Personally Identifiable Information (PII).</li><li>All sensitive information existing in hard copy must be stored in a locked container in a limited or exclusive area, an access controlled electronic environment, or be under the physical control of an authorized individual.</li><li>All inquiries on student data shall be related to a legitimate business and/or educational interest of the organization and shall not be used or motivated by any personal interest of an employee of the organization.</li><li>Electronic files must be properly encrypted.</li><li>Never save unencrypted information on an unsecured drive, including a computer\'s hard drive.</li><li>Never access data unless a legitimate relationship exists between the requestor and the student/student’s family.</li><li>Never leave computers logged on and unattended. Log off at the end of each session or use access control software (i.e., screen saver with password) during unattended use.</li><li>Never email FERPA- protected information except in an encrypted and password- protected attachment.</li><li>Never provide a password in the same email as an encrypted document.</li><li>Never view sensitive material while in a public place or on a shared, public computer.</li></ul><strong>Privacy of the User Accounts</strong><ul><li>Sharing User Accounts and passwords is a violation and will result in the individual, and potentially the organization, permanently losing access to system.</li><li>The User Accounts is assigned to an individual, not the organization.</li><li>Only the individual to whom a User Account is assigned can use that User Account to access the system.</li><li>Each individual is responsible for protecting his or her access, password, and the data in LEA Data Mapping application.</li><li>At no time should an individual be asked to provide their User Account and password to anyone. This includes the employee’s supervisor or management.</li><li>Individuals who are asked to provide their User Account and password to anyone must contact the OSSE Help Desk Technical Support Team at SLED.INFO@DC.GOV immediately.</li><li>An eligible organization that allows unauthorized access to the LEA Data Mapping application will be considered to have violated its responsibilities and places itself at risk of losing access to the system.</li><li>All organizations must train employees on the importance of maintaining the privacy of student data, and review its own policies, procedures, and agreements to ensure that it is in full compliance.</li><li>An eligible organization shall maintain an accurate and current listing of your organization\'s active users and provide such list to OSSE upon request.</li><li>Contact the OSSE Help Desk Technical Support Team at SLED.INFO@DC.GOV for deactivating users who are no longer employed or whose job no longer warrants access to the system.</li><li>It is required to report any person(s) to SLED.INFO@DC.GOV that is identified as using and or sharing the LEA Data Mapping application data inappropriately.</li></ul><p>I agree with the LEA Data Mapping application Privacy Policy. I understand that failure to abide by the above rules and responsibilities may lead to adverse action.</p></md-content></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=vm.accept()>I agree</md-button><md-button ng-click=vm.close()>Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/layout/layout.html","<div layout=column><navbar></navbar><div layout=row><div layout-fill ui-view class=slide></div><span flex></span><sidenav></sidenav></div></div>");
$templateCache.put("app/mappings/mappings.html","<md-progress-linear class=md-warn md-mode=indeterminate ng-show=vm.loading></md-progress-linear><form ng-submit=vm.updateMappings() class=backdrop><div layout-fill><md-card md-theme=default class=\"mapping-card-filter md-whiteframe-4dp\"><md-card-content layout=column><section layout-gt-sm=row layout=column><md-input-container flex=30 class=md-accent><label>School Year</label><md-select class=md-accent ng-model=vm.filter.schoolYear ng-change=vm.schoolYearFilterSelected() placeholder=\"Select a School Year\" ng-disabled=\"vm.schoolYearFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=sy ng-repeat=\"sy in vm.schoolYearFilters\">{{sy.Name}}</md-option></md-select></md-input-container><span flex=5></span><md-input-container flex=30 class=md-accent><label>LEA</label><md-select class=md-accent ng-model=vm.filter.lea ng-change=vm.leaFilterSelected() placeholder=\"Select an LEA\" ng-disabled=\"vm.leaFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=lea ng-repeat=\"lea in vm.leaFilters\">{{lea.Name}}</md-option></md-select></md-input-container><span flex=5></span><md-input-container flex=30 class=md-accent><label>Collection Type</label><md-select class=md-accent ng-model=vm.filter.collectionType ng-change=vm.collectionTypeFilterSelected() placeholder=\"Select a Collection Type\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=ct ng-repeat=\"ct in vm.collectionTypeFilters\">{{ct.Name}}</md-option></md-select></md-input-container></section><section layout-gt-sm=row layout=column><md-input-container class=md-accent flex=30><input ng-model=vm.filter.search placeholder=\"Filter mapping fields below\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\"></md-input-container><span flex=5></span><md-input-container flex=25 class=md-accent><label>Order mapping fields below by</label><md-select class=md-accent ng-model=vm.filter.orderBy placeholder=\"Order by\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=\"\'OSSEColumn.DisplayName\'\">Name A-Z</md-option><md-option class=md-accent ng-value=\"\'-OSSEColumn.DisplayName\'\">Name Z-A</md-option></md-select></md-input-container><span flex=5></span><md-input-container style=margin-top:10px flex=15><md-switch ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\" ng-model=vm.filter.showErrorsOnly>Showing {{vm.filter.showErrorsOnly ? \'Errors Only\':\'All\'}}</md-switch></md-input-container><span flex=5></span><md-input-container flex=10><md-button type=submit layout-align=\"start center\" class=\"md-raised md-primary\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading || vm.editingDisabled\">{{vm.editingDisabled ? \"Can\'t Edit Previous SchoolYear Mappings\" : vm.saveButtonText}}</md-button></md-input-container></section></md-card-content></md-card></div><div><md-card class=\"mapping-card-sis md-whiteframe-1dp mapping-card-sis-slide\" ng-class=\"vm.mappings.LEACollectionTypes[0].showQuery ? \'large\' : \'small\'\" md-theme=default ng-show=\"!vm.filter.showErrorsOnly && vm.filter.collectionType \"><md-card-content layout=column layout-align=\"end space-between\"><section layout-gt-xs=row layout=column layout-align=\"space-between start\"><md-input-container flex=grow class=\"sis-name-input md-accent\"><label>SIS Name</label><input ng-model=vm.mappings.LEACollectionTypes[0].SISType ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-input-container flex=grow class=\"sis-name-input md-accent\" ng-if=\"vm.filter.collectionType.Name === \'Attendance\'\"><label>Attendance Type</label><md-select class=md-accent ng-model=vm.mappings.LEACollectionTypes[0].AttendanceType placeholder=\"Select Attendance Type\" ng-disabled=\"vm.loading || vm.editingDisabled\"><md-option class=md-accent ng-value=val ng-repeat=\"val in [\'Positive\',\'Negative\']\">{{val}}</md-option></md-select></md-input-container><md-input-container flex=grow class=\"sis-name-input md-accent\" ng-if=\"vm.filter.schoolYear.Name < \'2019-2020\'\"><label>SIS Hosting Location</label><input ng-model=vm.mappings.LEACollectionTypes[0].SISHostingLocation ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-input-container flex=grow class=\"sis-name-input md-accent\" ng-if=\"vm.filter.schoolYear.Name > \'2018-2019\'\"><label>SIS Hosting Location</label><md-select class=md-accent ng-model=vm.mappings.LEACollectionTypes[0].SISHostingLocation placeholder=\"Select a Hosting Location\" ng-disabled=\"vm.loading || vm.editingDisabled\"><md-option class=md-accent ng-value=lea ng-repeat=\"lea in [\'LEA\',\'OSSE\',\'Vendor\']\">{{lea}}</md-option></md-select></md-input-container><md-input-container flex=grow class=\"sis-name-input md-accent\"><label>ADT Client Hosting Location</label><input ng-model=vm.mappings.LEACollectionTypes[0].ADTClientHostingLocation ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-input-container flex=grow class=\"sis-name-input md-accent\"><label>ADT Client Query Management</label><md-select class=md-accent ng-model=vm.mappings.LEACollectionTypes[0].ADTClientQueryManagement placeholder=\"Select ADT Client Query Management\" ng-disabled=\"vm.loading || vm.editingDisabled\"><md-option class=md-accent ng-value=lea ng-repeat=\"lea in [\'LEA\',\'OSSE\']\">{{lea}}</md-option></md-select></md-input-container><md-button flex=noshrink class=\"md-primary md-icon-button\" ng-click=\"vm.mappings.LEACollectionTypes[0].showQuery = !vm.mappings.LEACollectionTypes[0].showQuery\"><md-icon>code</md-icon></md-button></section><section ng-if=vm.mappings.LEACollectionTypes[0].showQuery layout=column><md-input-container class=md-accent flex><label>ADT Client Query</label><textarea ng-model=vm.mappings.LEACollectionTypes[0].ADTClientQuery rows=5 ng-disabled=\"vm.loading || vm.editingDisabled\"></textarea></md-input-container></section></md-card-content></md-card><div layout-gt-xs=row layout=column layout-wrap><section flex=50 flex-gt-sm=33 flex-gt-md=25 layout=column ng-repeat=\"leaMap in vm.mappings.LEAOSSEMappings | filter: {OSSEColumn: {DisplayName: vm.filter.search}} | filter: vm.getMappingVisibility | orderBy:vm.filter.orderBy\"><md-card ng-class=\"!vm.isRequiredColumnCompleted(leaMap) || vm.hasMappingErrors(leaMap) ? \'mapping-card error md-whiteframe-1dp\' : \'mapping-card md-whiteframe-1dp\'\" md-theme=default ng-show=vm.getMappingVisibility(leaMap)><md-card-title class=mapping-title><md-card-title-text>{{leaMap.OSSEColumn.DisplayName}} ({{leaMap.OSSEColumn.Format}})</md-card-title-text><md-button class=\"md-primary md-icon-button\" ng-click=\"leaMap.showDetails = ! leaMap.showDetails\" style=\"margin: -10px -15px 0px 0px\"><md-icon ng-show=!leaMap.showDetails>expand_more</md-icon><md-icon ng-show=leaMap.showDetails>expand_less</md-icon></md-button></md-card-title><md-card-content layout=column><section ng-show=leaMap.showDetails layout=column><md-input-container class=md-accent><label>Notes</label><textarea ng-model=leaMap.Notes rows=5 ng-disabled=\"vm.loading || vm.editingDisabled\"></textarea></md-input-container></section><section ng-show=!leaMap.showDetails layout=column><md-input-container class=md-accent><label>SIS Table</label><input ng-model=leaMap.SISTable ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-input-container class=md-accent><label>SIS Column</label><input ng-model=leaMap.SISColumn ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-card-actions layout=row layout-align=\"end center\" style=\"{{leaMap.LEAOSSEOptionMappings.length > 0 ? \'margin-top:-20px\' : \'margin-top:0px\' }}\"><md-icon ng-show=\"!vm.isRequiredColumnCompleted(leaMap) || vm.hasMappingErrors(leaMap)\" class=info-outline>info_outline</md-icon><span ng-show=\"vm.isRequiredColumnCompleted(leaMap) && vm.hasMappingErrors(leaMap)\">&nbsp;&nbsp;Option Errors</span> <span ng-show=!vm.isRequiredColumnCompleted(leaMap)>&nbsp;&nbsp;Required</span> <span flex></span><md-button ng-show=\"leaMap.LEAOSSEOptionMappings.length > 0\" class=\"map-options-btn md-primary\" ng-click=vm.showOptionMappingTableDialog(leaMap) ng-disabled=vm.loading>Map Options</md-button></md-card-actions></section></md-card-content></md-card></section><section flex-xs flex-gt-sm=33 layout=column ng-repeat=\"leaMap in vm.mappings.LEACustomMappings | filter: {CustomColumn: {DisplayName: vm.filter.search}}\" ng-show=!vm.filter.showErrorsOnly><md-card class=\"mapping-card md-whiteframe-3dp\" md-theme=default><md-card-title><md-card-title-text>{{leaMap.CustomColumn.DisplayName}} ({{leaMap.CustomColumn.Format}})</md-card-title-text></md-card-title><md-divider></md-divider><md-card-content layout=column><md-input-container class=md-accent><label>SIS Table</label><input ng-model=leaMap.SISTable ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container><md-input-container class=md-accent><label>SIS Column</label><input ng-model=leaMap.SISColumn ng-disabled=\"vm.loading || vm.editingDisabled\"></md-input-container></md-card-content></md-card></section></div></div></form>");
$templateCache.put("app/scheduler/scheduler.html","<div ng-cloak class=calendly-inline-widget-container><md-content class=calendly-inline-widget-container><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"Shacara Young\"><div class=calendly-inline-widget data-url=https://calendly.com/shacara-young/adt-data-mapping-configuration/03-15-2017 style=\"min-width: 320px; height: 580px\"></div><script type=text/javascript src=https://calendly.com/assets/external/widget.js></script></md-tab><md-tab label=\"Yvonne Huelcher\"><div class=calendly-inline-widget data-url=https://calendly.com/yvonne-huelcher/adt-data-mapping-configuration/ style=\"min-width: 320px; height: 580px\"></div><script type=text/javascript src=https://calendly.com/assets/external/widget.js></script></md-tab><md-tab label=\"Ahmad Alattar\"><div class=calendly-inline-widget data-url=https://calendly.com/ahmad-alattar/60min/ style=\"min-width: 320px; height: 580px\"></div><script type=text/javascript src=https://calendly.com/assets/external/widget.js></script></md-tab></md-tabs></md-content></div>");
$templateCache.put("app/components/auth/logoutWarning.html","<md-dialog id=session-timeout-dialog><form><md-toolbar class=\"md-default md-hue-2\"><div class=md-toolbar-tools><h2>{{vm.auth.isAuth ? \'Your session is ending in:\' : \'Your session timed out!\'}} &nbsp;</h2><timer ng-show=vm.auth.isAuth countdown=vm.timeLeft max-time-unit=\"\'minute\'\" interval=1000>{{mminutes}} minute{{minutesS}}, {{sseconds}} second{{secondsS}}</timer></div></md-toolbar><md-dialog-content><md-content class=md-padding><span ng-show=vm.auth.isAuth>Make sure to save all of your changes. You will be logged out automatically after your session ends.</span> <span ng-show=!vm.auth.isAuth>Please login again to make any changes.</span></md-content></md-dialog-content><md-dialog-actions layout=row><md-button ng-click=vm.close()>Ok</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/auth/sessionTimeoutToast.html","<md-toast id=sessionTimeoutToast><span class=md-toast-text flex><timer ng-show=vm.auth.isAuth countdown=vm.timeLeft max-time-unit=\"\'minute\'\" interval=1000>{{mminutes}} minute{{minutesS}}, {{sseconds}} second{{secondsS}} left in the session!</timer></span></md-toast>");
$templateCache.put("app/components/applicationUserAdmin/applicationUserAdmin.html","<div layout=column><md-content layout=column class=backdrop><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=md-toolbar-tools layout=row><md-input-container md-no-float class=\"md-block md-accent\" style=margin-top:35px><input ng-model=vm.searchFilter placeholder=\"Filter usernames\"><md-icon>search</md-icon></md-input-container><div flex></div><md-button class=\"md-button md-primary action-button\" ng-click=vm.addEditItem()><md-icon>add</md-icon>Add User</md-button><md-button ng-show=vm.authentication.isOSSEAdmin class=\"md-button md-primary action-button\" ng-click=vm.updateLEAAssociations()><md-icon>sync</md-icon>Sync LEAs</md-button><md-button ng-show=vm.authentication.isOSSEAdmin class=\"md-button md-primary action-button\" ng-click=vm.sendOSSESummary()><md-icon>mail</md-icon>OSSE</md-button><md-button ng-show=vm.authentication.isOSSEAdmin class=\"md-button md-primary action-button\" ng-click=vm.sendLEASummary()><md-icon>mail</md-icon>LEA</md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar md-default\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=md-toolbar-tools><span>Selected: {{vm.selected[0].Username}}</span><div flex></div><md-button class=\"md-button md-primary action-button\" ng-click=vm.addEditItem(vm.selected[0])><md-icon>edit</md-icon>Edit</md-button><md-button class=\"md-button md-primary action-button\" ng-click=vm.addEditItem(vm.selected[0],true)><md-icon>delete</md-icon>Delete</md-button></div></md-toolbar><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected md-progress=vm.loading><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-order-by=Username><span>Username</span></th><th ng-show=vm.authentication.isOSSEAdmin md-column><span>Notifications</span></th><th md-column><span>Roles</span></th><th md-column><span>LEAs</span></th></tr></thead><tbody md-body><tr md-row md-select=user md-auto-select=vm.options.autoSelect ng-repeat=\"user in vm.applicationUsers | filter: vm.searchFilter | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{user.Username}}</td><td ng-show=vm.authentication.isOSSEAdmin md-cell><md-checkbox ng-disabled=true ng-model=user.NotificationsEnabled></md-checkbox></td><td md-cell>{{vm.getUserRoles(user)}}</td><td md-cell>{{vm.getUserLEAs(user)}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.applicationUsers.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination></md-card></md-content></div>");
$templateCache.put("app/components/applicationUserAdmin/applicationUserAdminEdit.html","<form ng-submit=vm.saveItem()><div layout=column md-theme=default><md-toolbar class=\"md-default md-hue-2\"><div class=md-toolbar-tools><h2 ng-show=!vm.item.id>Add New Application User</h2><h2 ng-show=\"vm.item.id && !vm.item.deleted\">Edit Application User</h2><h2 ng-show=vm.item.deleted>Delete Application User?</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-content layout-padding><div layout=column><md-input-container class=md-accent><label>Username</label><input type=email required ng-disabled=\"vm.item.deleted || vm.loading\" ng-model=vm.item.username></md-input-container><md-input-container required class=md-accent><label>Role</label><md-select required ng-model=vm.item.roleID placeholder=\"Select a Role\" class=md-accent ng-disabled=\"vm.item.deleted  || vm.loading\"><md-option class=md-accent ng-value=role.ID ng-repeat=\"role in vm.roles\">{{role.Name}}</md-option></md-select></md-input-container><md-input-container class=md-accent ng-show=vm.authentication.isOSSEAdmin><md-switch ng-disabled=\"vm.item.deleted || vm.loading\" ng-model=vm.item.notificationsEnabled>Notifications {{vm.item.notificationsEnabled ? \'Enabled\':\'Disabled\'}}</md-switch></md-input-container><section layout=row><md-progress-circular ng-show=vm.loading class=md-warn md-mode=indeterminate md-diameter=50></md-progress-circular><md-button flex=\"{{vm.loading ? 80 : 100}}\" ng-show=!vm.item.id type=submit class=\"md-raised md-primary\" ng-disabled=vm.loading>Add User</md-button><md-button flex=\"{{vm.loading ? 80 : 100}}\" ng-show=\"vm.item.id && !vm.item.deleted\" type=submit class=\"md-raised md-primary\" ng-disabled=vm.loading>Update User</md-button><md-button flex=\"{{vm.loading ? 80 : 100}}\" ng-show=vm.item.deleted type=submit class=\"md-raised md-primary\" ng-disabled=vm.loading>Delete User</md-button></section><br><md-content ng-show=vm.errors.length style=color:#F44336 ng-repeat=\"error in vm.errors\"><i class=material-icons>error</i> {{error}}</md-content></div></md-content></div></form>");
$templateCache.put("app/components/navbar/navbar.html","<md-toolbar layout=row class=\"md-default md-hue-2\" layout-align=\"space-between center\"><section layout=row flex=nogrow><img ng-src=/ldm/assets/images/logo.svg style=\"margin: -1px 0px 0px -6px\" width=70 height=53><section layout=column layout-align=\"end start\"><span class=md-body-1>District of Columbia Office of the</span> <span class=md-body-1>State Superintendent of Education</span></section></section><span class=md-headline flex=25>LEA DATA MAPPING</span><section layout-align=\"end end\"><md-button ui-sref=login data-ng-hide=\"vm.authentication.isAuth \">Login</md-button><md-button ng-hide=\"!vm.authentication.isAuth \" ng-click=\"vm.toggleSidenav() \"><md-icon>menu</md-icon></md-button></section></md-toolbar>");
$templateCache.put("app/components/gaugeChart/gaugeChart.html","<ui-knob value=vm.value options=vm.options></ui-knob>");
$templateCache.put("app/components/sidenav/sidenav.html","<md-sidenav layout=column class=\"md-sidenav-right md-whiteframe-z2\" md-component-id=sidenav flex><md-toolbar class=md-hue-2 layout=row layout-padding layout-align=\"start end\"><div class=md-subhead style=\"overflow: hidden; text-overflow: ellipsis; width: 500px\">{{vm.authentication.username}}</div><span flex></span><md-button class=\"md-icon-button md-light\" ng-click=\"vm.toggleSidenav(\'sidenav\')\"><md-icon>close</md-icon></md-button></md-toolbar><md-list><section ng-show=vm.authentication.isAuth><md-subheader>General</md-subheader><md-list-item ng-click=\"vm.navigateTo(\'dashboard\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Dashboard</span></div></md-list-item><md-list-item ng-click=\"vm.navigateTo(\'mappings\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Edit Mappings</span></div></md-list-item><md-list-item ng-click=\"vm.navigateTo(\'mappingsHistory\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Mappings History</span></div></md-list-item><md-list-item ng-click=\"vm.navigateTo(\'scheduler\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Scheduler</span></div></md-list-item><md-list-item ng-click=\"vm.openExternalUrl(\'/ldm/assets/template.xlsx\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Download LEA Data Collection Template</span></div></md-list-item><md-list-item ng-click=\"vm.openExternalUrl(\'/ldm/assets/course_template.xlsx\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Download LEA Course Collection Template</span></div></md-list-item><md-list-item ng-click=\"vm.logOut(\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Log Out</span></div></md-list-item><section ng-show=vm.authentication.isOSSEAdmin><md-divider></md-divider><md-subheader>Settings</md-subheader><md-list-item ng-click=vm.toggleNotificationsEnabled() md-ink-ripple=#2196f3><md-switch ng-disabled=\"vm.item.deleted || vm.loading\" ng-model=vm.settings.notificationsEnabled aria-label=\"Enable Notifications\"></md-switch><span class=md-body-2>Notifications {{vm.settings.notificationsEnabled ? \'Enabled\':\'Disabled\'}}</span></md-list-item></section><section ng-show=vm.authentication.isOSSEUser><md-divider></md-divider><md-subheader>Admin</md-subheader><md-list-item ng-click=\"vm.navigateTo(\'admin\',\'sidenav\')\" md-ink-ripple=#2196f3><div class=md-list-item-text><span class=md-body-2>Manage Users</span></div></md-list-item></section></section><md-list-item ng-click=\"vm.navigateTo(\'login\',\'sidenav\')\" md-ink-ripple=#2196f3 ng-show=!vm.authentication.isAuth><div class=md-list-item-text><span class=md-body-2>Login</span></div></md-list-item></md-list></md-sidenav>");
$templateCache.put("app/dashboard/optionErrorsTable/optionErrorsTable.html","<div layout=column><br><md-content layout=column><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=vm.searchFilterEnabled><div class=md-toolbar-tools style=display:inline-block><md-input-container md-no-float class=\"md-block md-accent\"><input ng-model=vm.query.filter placeholder=\"Filter columns\"><md-icon>search</md-icon></md-input-container></div></md-toolbar><md-card-content><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected animate-sort-icon=true><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-order-by=OSSEColumnName><span>OSSE Column</span></th><th md-column md-order-by=Value><span>Unmapped Value</span></th><th md-column md-order-by=Count><span>Records Affected</span></th></tr></thead><tbody md-body><tr md-row md-select=col md-auto-select=vm.options.autoSelect ng-repeat=\"err in vm.LEAOSSEOptionMappingErrors | filter:vm.query.filter:strict | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{err.OSSEColumnName}}</td><td md-cell>{{err.Value}}</td><td md-cell>{{err.Count}}</td><td md-cell><md-button class=md-primary ng-click=\"vm.goToEditMappings(vm.schoolYear, vm.lea, vm.collectionType, err.OSSEColumnName)\">Fix Errors</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.LEAOSSEOptionMappingErrors.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=md-primary ng-click=vm.closeDialog()>Close</md-button></md-card-actions></md-card></md-content></div>");
$templateCache.put("app/dashboard/requiredErrorsTable/requiredErrorsTable.html","<div layout=column><br><md-content layout=column><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=vm.searchFilterEnabled><div class=md-toolbar-tools style=display:inline-block><md-input-container md-no-float class=\"md-block md-accent\"><input ng-model=vm.query.filter placeholder=\"Filter columns\"><md-icon>search</md-icon></md-input-container></div></md-toolbar><md-card-content><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected animate-sort-icon=true><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-order-by=OSSEColumnName><span>OSSE Column</span></th><th md-column><span>Error</span></th></tr></thead><tbody md-body><tr md-row md-select=col md-auto-select=vm.options.autoSelect ng-repeat=\"col in vm.leaOSSERequiredMappings | filter:vm.query.filter:strict | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{col.OSSEColumnName}}</td><td md-cell>{{vm.errorMappingMsg(col.SISTableEmpty,col.SISColumnEmpty)}}</td><td md-cell><md-button class=md-primary ng-click=\"vm.goToEditMappings(vm.schoolYear, vm.lea, vm.collectionType, col.OSSEColumnName)\">Fix Errors</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.leaOSSERequiredMappings.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination></md-card-content><md-card-actions layout=row layout-align=\"end center\"><md-button class=md-primary ng-click=vm.closeDialog()>Close</md-button></md-card-actions></md-card></md-content></div>");
$templateCache.put("app/mappings/history/mappingsHistory.html","<md-progress-linear class=md-warn md-mode=indeterminate ng-show=vm.loading></md-progress-linear><form ng-submit=vm.updateMappings()><div layout-fill><md-card md-theme=default class=\"mapping-card-filter md-whiteframe-4dp\"><md-card-content layout=column><section layout-gt-sm=row layout=column><md-input-container flex=30 class=md-accent><label>School Year</label><md-select class=md-accent ng-model=vm.filter.schoolYear ng-change=vm.schoolYearFilterSelected() placeholder=\"Select a School Year\" ng-disabled=\"vm.schoolYearFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=sy ng-repeat=\"sy in vm.schoolYearFilters\">{{sy.Name}}</md-option></md-select></md-input-container><span flex=5></span><md-input-container flex=30 class=md-accent><label>LEA</label><md-select class=md-accent ng-model=vm.filter.lea ng-change=vm.leaFilterSelected() placeholder=\"Select an LEA\" ng-disabled=\"vm.leaFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=lea ng-repeat=\"lea in vm.leaFilters\">{{lea.Name}}</md-option></md-select></md-input-container><span flex=5></span><md-input-container flex=30 class=md-accent><label>Collection Type</label><md-select class=md-accent ng-model=vm.filter.collectionType ng-change=vm.collectionTypeFilterSelected() placeholder=\"Select a Collection Type\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\"><md-option class=md-accent ng-value=ct ng-repeat=\"ct in vm.collectionTypeFilters\">{{ct.Name}}</md-option></md-select></md-input-container></section><section layout-gt-sm=row layout=column><div flex=60 style=\"padding-top: 15px\" class=md-accent><span>History between:</span><md-datepicker class=md-accent ng-model=vm.filter.startDate md-max-date=vm.filter.maxDate md-placeholder=\"Enter date\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\" ng-change=vm.dateFilterSelected()></md-datepicker><span>&nbsp;&nbsp;&nbsp;&nbsp;and</span><md-datepicker class=md-accent ng-model=vm.filter.endDate md-max-date=vm.filter.maxDate md-placeholder=\"Enter date\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\" ng-change=vm.dateFilterSelected()></md-datepicker></div><span flex=5></span><md-input-container flex=35 class=md-accent><input ng-model=vm.query.filter placeholder=\"Filter mapping fields below\" ng-disabled=\"vm.collectionTypeFilterDisabled || vm.loading\"></md-input-container></section></md-card-content></md-card></div></form><div layout=column><br><md-content layout=column class=backdrop><md-card><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected md-progress=vm.loading><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-order-by=ChangeType><span>Change Type</span></th><th md-column md-order-by=ColumnName><span>Column</span></th><th md-column md-order-by=OptionName><span>Option</span></th><th md-column md-order-by=OldValue><span>Old Value</span></th><th md-column md-order-by=NewValue><span>New Value</span></th><th md-column md-order-by=Updated><span>Updated</span></th><th md-column md-order-by=UpdatedBy><span>Updated By</span></th></tr></thead><tbody md-body><tr md-row md-auto-select=vm.options.autoSelect ng-repeat=\"record in vm.mappingsHistory | filter: vm.query.filter:strict | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{record.ChangeType}}</td><td md-cell>{{record.ColumnName}}</td><td md-cell>{{record.OptionName}}</td><td md-cell>{{record.OldValue}}</td><td md-cell>{{record.NewValue}}</td><td md-cell>{{record.Updated.replace(\'T\',\' \')}}</td><td md-cell>{{record.UpdatedBy}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.mappingsHistory.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination></md-card></md-content></div>");
$templateCache.put("app/mappings/optionMappingTable/optionMappingTable.html","<div layout=column><br><md-content layout=column><md-card><span layout-padding style=color:#C62828 class=md-caption>{{vm.optionError}}</span><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=vm.searchFilterEnabled><div class=md-toolbar-tools style=display:inline-block><md-input-container md-no-float class=\"md-block md-accent\"><input ng-model=vm.query.filter placeholder=\"Filter options to map\"><md-icon>search</md-icon></md-input-container></div></md-toolbar><br><md-card-content layout=column><md-table-container style=margin-top:-30px><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-order-by=Option.Name><span>OSSE Value Descriptor</span></th><th md-column md-order-by=Option.Value><span>OSSE Value</span></th><th md-column md-order-by=SISValue><span>SIS Value</span></th><th md-column md-order-by=Option.Value><span>Not in SIS</span></th></tr></thead><tbody md-body><tr md-row md-select=opt md-auto-select=vm.options.autoSelect ng-repeat=\"opt in vm.optionMap.LEAOSSEOptionMappings | filter: {Option: {Name: vm.query.filter}} | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{opt.Option.Name}}</td><td md-cell>{{opt.Option.Value}}</td><td class=md-accent md-cell ng-click=\"opt.isNULL || vm.editingDisabled || vm.editSISValue($event, opt, vm.optionMap.LEAOSSEOptionMappings)\" ng-class=\"{\'md-placeholder\': !opt.SISValue}\"><md-icon class=md-primary>edit</md-icon>&nbsp;&nbsp; {{opt.isNULL ? \"[NOT IN SIS]\" : opt.SISValue || \'Add comma seperated values\'}}</td><td md-cell><md-checkbox ng-model=opt.isNULL ng-change=vm.setSISValueNull(opt) ng-disabled=vm.editingDisabled aria-label=\"Is Null\"></md-checkbox></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.optionMap.LEAOSSEOptionMappings.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination><section style=color:#C62828 ng-show=vm.optionMap.LEAOSSEOptionMappingErrors.length><span class=md-caption>Errors: {{vm.getErrorsString(vm.optionMap.LEAOSSEOptionMappingErrors)}}</span></section></md-card-content><md-card-actions layout=row layout-align=\"end center\" style=\"{{leaMap.LEAOSSEOptionMappings.length > 0 ? \'margin-top:-20px\' : \'margin-top:0px\' }}\"><md-button class=md-primary ng-click=vm.closeDialog()>Close</md-button></md-card-actions></md-card></md-content></div>");
$templateCache.put("app/components/collectionTypes/admin/collectionTypesAdmin.html","<div layout=column><br><md-content layout=column flex><md-card><md-toolbar class=\"md-table-toolbar md-default\" ng-hide=\"vm.options.rowSelection && vm.selected.length\"><div class=md-toolbar-tools><span>Collection Types</span><div flex></div><md-button class=md-icon-button><md-icon>search</md-icon></md-button><md-button class=md-icon-button ng-click=vm.addItem($event)><md-icon>add</md-icon></md-button><md-button class=md-icon-button ng-click=vm.saveChanges()><md-icon>save</md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-table-toolbar alternate\" ng-show=\"vm.options.rowSelection && vm.selected.length\"><div class=md-toolbar-tools><span>{{vm.selected.length}} {{vm.selected.length > 1 ? \'items\' : \'item\'}}</span><div flex></div><md-button class=md-icon-button ng-click=vm.deleteSelectedItems()><i class=\"material-icons md-light\">delete</i></md-button></div></md-toolbar><md-table-container><table md-table md-row-select=vm.options.rowSelection multiple ng-model=vm.selected md-progress=vm.promise><thead ng-if=!vm.options.decapitate md-head md-order=vm.query.order><tr md-row><th md-column md-numeric md-order-by=ID md-desc><span>ID</span></th><th md-column md-order-by=SchoolYear.Name><span>School Year</span></th><th md-column md-order-by=Name><span>Name</span></th><th md-column md-order-by=Description><span>Description</span></th><th md-column md-order-by=Inactive><span>Inactive</span></th></tr></thead><tbody md-body><tr md-row md-select=ct md-auto-select=vm.options.autoSelect ng-repeat=\"ct in vm.collectionTypes | filter: vm.filter.search | orderBy: vm.query.order | limitTo: vm.query.limit : (vm.query.page -1) * vm.query.limit\"><td md-cell>{{ct.ID}}</td><td md-cell>{{ct.SchoolYear.Name}}</td><td md-cell>{{ct.Name}}</td><td md-cell ng-click=\"vm.editDescription($event, ct)\" ng-class=\"{\'md-placeholder\': !ct.Description}\">{{ct.Description || \'Add a description\'}}</td><td md-cell><md-checkbox class=md-secondary ng-model=ct.Inactive></md-checkbox></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=vm.query.limit md-limit-options=vm.limitOptions md-page=vm.query.page md-total={{vm.collectionTypes.length}} md-page-select=vm.options.pageSelect md-boundary-links=vm.options.boundaryLinks></md-table-pagination></md-card></md-content></div>");
$templateCache.put("app/components/collectionTypes/admin/collectionTypesAdminAdd.html","<form ng-submit=vm.saveItem()><div layout=column><md-toolbar><div class=md-toolbar-tools><h2>Add New Collection Type</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeDialog()><md-icon>close</md-icon></md-button></div></md-toolbar><md-content layout-padding><div layout=column><md-select ng-model=vm.item.schoolYear placeholder=\"Select a School Year\"><md-option ng-value=sy.Name ng-repeat=\"sy in vm.schoolYears\">{{sy.Name}}</md-option></md-select><md-input-container ng-disabled=true><label>Name</label><input ng-model=vm.item.name></md-input-container><md-input-container ng-disabled=true>><label>Description</label><textarea ng-model=vm.item.description></textarea></md-input-container><md-input-container><md-checkbox class=md-secondary ng-model=vm.item.Inactive>Inactive</md-checkbox></md-input-container><md-button type=submit class=\"md-raised md-primary\">Save</md-button></div></md-content></div></form>");}]);